<div class="card">
  <div class="flex flex-col gap-6 items-center w-full" *ngIf="ready">
    <div class="w-full">
      <button
        class="button-elevation p-2 rounded-full"
        (click)="goBackToEnigma()"
      >
        Torna all'enigma
      </button>
    </div>

    <div class="w-full shadow-medium p-4 rounded-3xl">
      <p class="text-2xl">Storia</p>
      <app-dynamic-form
        #myForm
        [options]="form2Opts"
        [fields]="regConfig2"
        (resetData)="initializeForm()"
        (submit)="submit($event)"
      >
      </app-dynamic-form>
    </div>
    <app-edit-history [data]="editHistoryData"></app-edit-history>
  </div>
</div>
